export default __webpack_public_path__ + "static/image165-903ab0619bc26ad1fb71dde74855c56c.jpg";